import React from 'react';
import { Card, CardContent, Grid, Typography, makeStyles } from '@material-ui/core';
import FileIcon from '../../assets/FileIcon';
import ZeroState from '../common/ZeroState';

const useStyles = makeStyles(() => ({
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  secondaryTextRed: {
    paddingLeft: '5px',
    marginTop: '4px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    color: 'rgba(255, 0, 0, 1)',
  },
  secondaryText: {
    paddingLeft: '5px',
    marginTop: '4px',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '15px',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  cardContent: {
    marginRight: '10px',
    borderRadius: '8px',
    marginTop: '10px',
    marginBottom: '5px',
    cursor: 'pointer',
  },
  cardBottom: {
    marginTop: '10px',
    marginBottom: '-10px',
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

const RuleItem = ({ rule, handleRuleClick }) => {
  const classes = useStyles();

  return (
    <Card className={classes.cardContent} onClick={() => handleRuleClick(rule.id)}>
      <CardContent>
        <Typography className={classes.primaryText} gutterBottom>
          {rule.name}
        </Typography>
        <div className={classes.cardBottom}>
          <span className={classes.secondaryText}>{rule.journeysCount || 0} journeys</span>
        </div>
      </CardContent>
    </Card>
  );
};

export default function RuleList({ rules = [], filteredArray = [], handleRuleClick }) {
  return rules.length ? (
    <Grid container>
      {filteredArray?.map((rule) => (
        <Grid item md={3} key={rule.id}>
          <RuleItem rule={rule} handleRuleClick={handleRuleClick} />
        </Grid>
      ))}
    </Grid>
  ) : (
    <ZeroState
      Icon={FileIcon}
      text="This custom group has not been added to any rule yet."
      style={{ paddingBottom: '100px', paddingTop: '30px' }}
      cardWidth="35%"
    />
  );
}
